<footer class="bg-slate-900 py-12 text-slate-200">
  <div class="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
    <div class="grid gap-10 grid-cols-2 lg:grid-cols-4">
      <div class="col-span-2 lg:col-span-1 space-y-4">
        <h3 class="text-2xl font-extrabold tracking-tight text-transparent bg-clip-text bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500">
          CodeBlack Technologies LLC
        </h3>
        <p class="text-sm leading-relaxed text-slate-400">
          For dancers, by dancers. Discover amazing dance experiences near you.
        </p>
        <div class="flex flex-wrap items-center gap-3 pt-2">
          <a
            href="https://apps.apple.com/us/app/danceup-users/id6791647812"
            target="_blank"
            rel="noopener noreferrer"
            class="inline-flex items-center gap-2 rounded-xl border border-slate-700 bg-slate-800 px-3.5 py-2 transition-colors hover:border-slate-600 hover:bg-slate-700"
            aria-label="Download DanceUP on the App Store"
          >
            <svg viewBox="0 0 24 24" class="h-6 w-6 fill-current text-white">
              <path d="M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zm3.415-3.132c.843-1.012 1.4-2.427 1.245-3.828-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.56-1.704z"/>
            </svg>
            <span class="text-left leading-tight">
              <span class="block text-[9px] uppercase tracking-wide text-slate-400">Download on the</span>
              <span class="block text-sm font-semibold text-white">App Store</span>
            </span>
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.danceup.danceup_users"
            target="_blank"
            rel="noopener noreferrer"
            class="inline-flex items-center gap-2 rounded-xl border border-slate-700 bg-slate-800 px-3.5 py-2 transition-colors hover:border-slate-600 hover:bg-slate-700"
            aria-label="Get DanceUP on Google Play"
          >
            <svg viewBox="0 0 24 24" class="h-6 w-6 fill-current text-white">
              <path d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 01-.61-.92V2.734a1 1 0 01.609-.92zm10.89 10.893l2.302 2.302-10.937 6.333 8.635-8.635zm3.199-3.198l2.807 1.626a1 1 0 010 1.73l-2.808 1.626-2.302-2.301 2.303-2.301zM5.864 2.658L16.802 8.99l-2.303 2.303-8.635-8.635z"/>
            </svg>
            <span class="text-left leading-tight">
              <span class="block text-[9px] uppercase tracking-wide text-slate-400">GET IT ON</span>
              <span class="block text-sm font-semibold text-white">Google Play</span>
            </span>
          </a>
        </div>
      </div>

      <div>
        <h4 class="text-lg font-semibold text-white">Quick Links</h4>
        <ul class="mt-4 space-y-2 text-sm text-slate-400">
          <li>
            <a routerLink="/classes" class="transition-colors hover:text-white">Classes</a>
          </li>
          <li>
            <a routerLink="/events" class="transition-colors hover:text-white">Events</a>
          </li>
          <li>
            <a routerLink="/studios" class="transition-colors hover:text-white">Studios</a>
          </li>
          <li>
            <a href="#about" class="transition-colors hover:text-white">About</a>
          </li>
        </ul>
      </div>

      <div>
        <h4 class="text-lg font-semibold text-white">Support</h4>
        <ul class="mt-4 space-y-2 text-sm text-slate-400">
          <li>
            <a routerLink="/help" class="transition-colors hover:text-white">Help Center</a>
          </li>
          <li>
            <a routerLink="/contact" class="transition-colors hover:text-white">Contact Us</a>
          </li>
          <li>
            <a routerLink="/privacy" class="transition-colors hover:text-white">Privacy Policy</a>
          </li>
          <li>
            <a routerLink="/terms" class="transition-colors hover:text-white">Terms of Service</a>
          </li>
        </ul>
      </div>

      <div class="col-span-2 lg:col-span-1">
        <h4 class="text-lg font-semibold text-white">Connect</h4>
        <div class="mt-4 flex flex-wrap gap-3">
          <a
            href="https://www.instagram.com/danceupapp/"
            target="_blank"
            rel="noopener noreferrer"
            class="flex h-10 w-10 items-center justify-center rounded-lg bg-white/10 text-slate-400 transition-all hover:-translate-y-0.5 hover:bg-indigo-500 hover:text-white"
            aria-label="Instagram"
          >
            <svg viewBox="0 0 24 24" class="h-5 w-5 fill-current">
              <path
                d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"
              />
            </svg>
          </a>
          <a
            href="https://www.facebook.com/profile.php?id=61590045094059"
            target="_blank"
            rel="noopener noreferrer"
            class="flex h-10 w-10 items-center justify-center rounded-lg bg-white/10 text-slate-400 transition-all hover:-translate-y-0.5 hover:bg-indigo-500 hover:text-white"
            aria-label="Facebook"
          >
            <svg viewBox="0 0 24 24" class="h-5 w-5 fill-current">
              <path
                d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"
              />
            </svg>
          </a>
          <a
            href="https://x.com/DanceUpApp"
            target="_blank"
            rel="noopener noreferrer"
            class="flex h-10 w-10 items-center justify-center rounded-lg bg-white/10 text-slate-400 transition-all hover:-translate-y-0.5 hover:bg-indigo-500 hover:text-white"
            aria-label="Twitter"
          >
            <svg viewBox="0 0 24 24" class="h-5 w-5 fill-current">
              <path
                d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"
              />
            </svg>
          </a>
        </div>
      </div>
    </div>

    <div class="mt-12 border-t border-slate-700 pt-6 text-center text-sm text-slate-500">
      <p>&copy; {{ year }} CodeBlack Technologies LLC. All rights reserved.</p>
    </div>
  </div>
</footer>
